import React from 'react';

export default function ParallelGroup({ children }) {
  return (
    <div className="relative border-1.5 border-dashed border-parallel rounded-lg p-3 pt-5 flex flex-col gap-2">
      <span className="absolute -top-2.5 left-3 bg-paper px-1.5 text-xs font-bold uppercase tracking-wider text-pencil">
        AT THE SAME TIME
      </span>
      {children}
    </div>
  );
}
